<!-- Indeterminate State -->
@if (!isDeterminate) {
  <div class="p-progressbar-indeterminate">
    @if (show) {
      <div class="p-progressbar-value p-progressbar-value-animate"></div>
    }
  </div>
}

<!-- Determinate State -->
@if (isDeterminate) {
  <div class="p-progressbar-determinate" [style.width.%]="value">
    @if (show) {
      <div class="p-progressbar-value"></div>
    }
  </div>
}
